import React, { useEffect, useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const ThemeProvider = ({ children }) => {
  const [themeLoaded, setThemeLoaded] = useState(false);

  useEffect(() => {
    const applyTheme = async () => {
      try {
        const { data } = await axios.get(`${BACKEND_URL}/api/settings/global`);
        
        // Apply CSS custom properties
        const root = document.documentElement;
        
        // Text color
        if (data.site_text_color) {
          root.style.setProperty('--site-text-color', data.site_text_color);
        }
        
        // Background color with transparency
        if (data.site_background_color) {
          root.style.setProperty('--site-background-color', data.site_background_color);
          const bgTransparency = data.site_background_transparency ?? 1;
          root.style.setProperty('--site-background-transparency', bgTransparency);
          
          // Convert hex to rgba
          const hex = data.site_background_color.replace('#', '');
          const r = parseInt(hex.substring(0, 2), 16);
          const g = parseInt(hex.substring(2, 4), 16);
          const b = parseInt(hex.substring(4, 6), 16);
          root.style.setProperty('--site-background-rgba', `rgba(${r}, ${g}, ${b}, ${bgTransparency})`);
        }
        
        // Primary/Accent color
        if (data.site_primary_color) {
          root.style.setProperty('--site-primary-color', data.site_primary_color);
          // Also update the CSS primary variable used by shadcn
          root.style.setProperty('--primary', data.site_primary_color);
        }
        
        // Header transparency
        const headerTransparency = data.site_header_transparency ?? 0.9;
        root.style.setProperty('--site-header-transparency', headerTransparency);
        
        // Card transparency
        const cardTransparency = data.site_card_transparency ?? 0.8;
        root.style.setProperty('--site-card-transparency', cardTransparency);
        
        // Apply styles to body
        document.body.style.color = data.site_text_color || '#ffffff';
        
      } catch (error) {
        console.log('Using default theme');
      } finally {
        setThemeLoaded(true);
      }
    };

    applyTheme();
    
    // Listen for theme changes (refresh every 30 seconds)
    const interval = setInterval(applyTheme, 30000);
    return () => clearInterval(interval);
  }, []);

  return <>{children}</>;
};

export default ThemeProvider;
